// arithmetic template - bet-math feedback on the typed dollar amount. ENGINE_DESIGN.md §8.2
// (arithmetic feedback is templates), §7.1/§7.3 (arithmeticVerdict + sizingFit are graded SEPARATELY).
// The template RENDERS the verdict grading already produced; it never re-grades. It may show the target
// dollar amount (mechanical arithmetic from SIZING_FRACTION) so the player sees the number they were
// aiming at - this is display, not scoring.
import { SIZING_FRACTION } from '@postflop/schema';
import { money } from '../cards';
const VERDICT_PHRASE = {
    exact: { label: 'spot on', tone: 'good' },
    close: { label: 'close', tone: 'neutral' },
    off: { label: 'off', tone: 'bad' },
};
const FIT_PHRASE = {
    fits: { label: 'fits the spot', tone: 'good' },
    too_small: { label: 'too small for the spot', tone: 'caution' },
    too_big: { label: 'too big for the spot', tone: 'caution' },
};
/** The dollar amount the sizing intent targets. Bet = fraction × pot; raise = pot-AFTER-call
 *  (toCall + fraction × (pot+toCall)) - the grading convention (ENGINE_DESIGN.md §7.3). min/jam are
 *  context-computed (not a fixed fraction) → null, so the template shows the verdict without a target. */
function targetAmount(intent, pot, toCall) {
    if (intent === 'min' || intent === 'jam')
        return null;
    const frac = SIZING_FRACTION[intent];
    if (frac === undefined)
        return null;
    return toCall > 0 ? toCall + frac * (pot + toCall) : frac * pot;
}
/**
 * Feedback on the player's own bet math: whether the typed amount was arithmetically right for the
 * chosen intent, and whether that intent fit the spot (two separate dimensions, §7.3). Empty when the
 * player has not acted (no userAction) - the do-your-own-math loop hasn't produced a number yet.
 */
export function arithmetic(facts) {
    const ua = facts.userAction;
    if (!ua)
        return [];
    const lines = [];
    if (ua.arithmeticVerdict) {
        const { label, tone } = VERDICT_PHRASE[ua.arithmeticVerdict];
        const typed = ua.typedAmount !== undefined ? `Your ${money(ua.typedAmount)}` : 'Your amount';
        const target = ua.sizingIntent !== undefined
            ? targetAmount(ua.sizingIntent, facts.math.pot, facts.math.toCall)
            : null;
        const aim = target !== null ? `, the target was about ${money(target)}` : '';
        lines.push({ kind: 'arithmetic', text: `${typed} is ${label}${aim}.`, tone });
    }
    if (ua.sizingFit) {
        const { label, tone } = FIT_PHRASE[ua.sizingFit];
        lines.push({ kind: 'sizing', text: `Your sizing ${label}.`, tone });
    }
    return lines;
}
//# sourceMappingURL=arithmetic.js.map